import {useDispatch} from 'react-redux'

export const useSetAndCacheFilter = ({orgCacheKey, name, filterName, clearFilters}) => {
	const dispatch = useDispatch()
	return filterValue => dispatch({type: 'FILTERS', orgCacheKey, name, filterName, filterValue, clearFilters})
}
